var React = require('react');

function DepositIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M336,151.913v-36.132l46.313-92.625c2.477-4.961,2.211-10.852-0.703-15.57C378.695,2.875,373.547,0,368,0h-64  c-4.242,0-8.313,1.688-11.313,4.688L272,25.375L251.313,4.688c-3-3-7.07-4.688-11.313-4.688h-96c-5.547,0-10.695,2.875-13.609,7.586  c-2.914,4.719-3.18,10.609-0.703,15.57L176,115.781v36.132C104.824,204.277,48,309.69,48,391.648C48,512,153.742,512,256,512  s208,0,208-120.352C464,309.69,407.176,204.277,336,151.913z M208,128h96v16h-96V128z M233.375,32l27.313,27.313  c6.25,6.25,16.375,6.25,22.625,0L310.625,32h31.484l-32,64H201.891l-32-64H233.375z M256,480c-125.063,0-176-7.992-176-88.352  C80,326.914,126.844,226,197.008,176h117.984C385.156,226,432,326.914,432,391.648C432,472.008,381.063,480,256,480z"}));
}

DepositIcon.defaultProps = {"version":"1.1","viewBox":"0 0 512 512","enableBackground":"new 0 0 512 512"};

module.exports = DepositIcon;

DepositIcon.default = DepositIcon;
